import "./Pricing.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import NosForfaitsPremium from "./sections/NosForfaitsPremium";
import AiVsTraditionalDevelopment from "./sections/AiVsTraditionalDevelopment";
import CommonQuestionsFaq from "./sections/CommonQuestionsFaq";
import LocationAndServiceAreasRepairService from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <VoltMainHeader />
      <NosForfaitsPremium />
      <AiVsTraditionalDevelopment />
      <CommonQuestionsFaq />
      <LocationAndServiceAreasRepairService />
    </div>;
}